import { selectAnatomy as parts } from '@chakra-ui/anatomy';
import {
    createMultiStyleConfigHelpers,
    defineStyle,
} from '@chakra-ui/styled-system';
import { mode } from '@chakra-ui/theme-tools';
import Input from './input';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyleField = defineStyle((props) => {
    return {
        ...Input.baseStyle?.field,
        bg: mode('white', 'gray.700')(props),
        appearance: 'none',
        paddingBottom: '1px',
        lineHeight: 'normal',
        '> option, > optgroup': {
            bg: mode('white', 'gray.700')(props),
        },
    };
});

const baseStyleIcon = defineStyle({
    width: '1.5rem',
    height: '100%',
    insetEnd: '0.5rem',
    position: 'relative',
    color: 'currentColor',
    fontSize: '1.25rem',
    _disabled: {
        opacity: 0.5,
    },
});

const baseStyle = defineStyle((props) => ({
    field: baseStyleField(props),
    icon: baseStyleIcon,
}));

const iconSpacing = defineStyle({ paddingInlineEnd: '2rem' });

const sizes = {
    xl: {
        ...Input.sizes?.xl,
        field: {
            ...Input.sizes?.xl.field,
            ...iconSpacing,
        },
    },
    lgr: {
        ...Input.sizes?.lgr,
        field: {
            ...Input.sizes?.lgr.field,
            ...iconSpacing,
        },
    },
    lg: {
        ...Input.sizes?.lg,
        field: {
            ...Input.sizes?.lg.field,
            ...iconSpacing,
        },
    },
    md: {
        ...Input.sizes?.md,
        field: {
            ...Input.sizes?.md.field,
            ...iconSpacing,
        },
    },
    sm: {
        ...Input.sizes?.sm,
        field: {
            ...Input.sizes?.sm.field,
            ...iconSpacing,
        },
    },
    xs: {
        ...Input.sizes?.xs,
        field: {
            ...Input.sizes?.xs.field,
            ...iconSpacing,
        },
        icon: { insetEnd: '0.25rem' },
    },
};

const selectTheme = defineMultiStyleConfig({
    baseStyle,
    sizes,
    variants: Input.variants,
    defaultProps: Input.defaultProps,
});

export default selectTheme;
